// 错误文案映射(PRD v4 05 章 U15):统一把接口/网络错误转成用户可读文案,
// 替代直出 e.message。新代码一律用 getErrorText(e, fallback)。
import { AxiosError } from "axios";

const CODE_TEXT: Record<number, string> = {
  400: "请求参数有误,请检查后重试",
  401: "登录状态已失效,请重新登录",
  403: "没有权限执行此操作",
  404: "请求的资源不存在",
  409: "操作冲突,请刷新后重试",
  413: "提交内容过大",
  429: "请求过于频繁,请稍后再试",
  500: "服务器开小差了,请稍后重试",
  502: "服务暂时不可用,请稍后重试",
  503: "服务暂时不可用,请稍后重试",
  504: "请求超时,请稍后重试",
};

/**
 * 把任意错误对象转换为用户可读文案。
 * 优先级:后端返回的 msg > HTTP 状态码映射 > 网络/超时识别 > fallback。
 */
type ErrorPayload = {
  msg?: string;
  message?: string;
  error_id?: string;
  errorId?: string;
};

function withErrorId(text: string, payload?: ErrorPayload): string {
  const errorId = payload?.error_id || payload?.errorId;
  return errorId ? `${text}（Error ID: ${errorId}）` : text;
}

export function getErrorText(error: unknown, fallback = "操作失败,请重试"): string {
  if (!error) return fallback;

  const axiosErr = error as AxiosError<ErrorPayload>;
  const payload = axiosErr?.response?.data;
  const serverMsg = payload?.msg || payload?.message;
  if (serverMsg && typeof serverMsg === "string") {
    return withErrorId(serverMsg, payload);
  }

  const status = axiosErr?.response?.status;
  if (status && CODE_TEXT[status]) {
    return withErrorId(CODE_TEXT[status], payload);
  }

  const code = (axiosErr as AxiosError)?.code;
  if (code === "ECONNABORTED" || code === "ETIMEDOUT") {
    return "请求超时,请检查网络后重试";
  }
  if (axiosErr?.request && !axiosErr?.response) {
    return "网络异常,请检查网络连接";
  }

  return withErrorId(fallback, payload);
}

export default getErrorText;
